module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "custom-call-to-action"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Can’t find what you’re looking for?")]), _c('br'), _vm._v("\n    Let us help you with a "), _c('a', {
    on: {
      "click": _vm.openChat
    }
  }, [_vm._v("custom protocol.")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('h2', [_vm._v("Custom"), _c('br'), _vm._v("Protocol")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-686649b9!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CalloutDocs.vue
// module id = 159
// module chunks = 2